<template>
  <LayoutHeader main="account" ref="layout" :loadingOverlay="loadingOverlay" :me="me" :lastApp="lastApp" :appHistory="appHistory">
    <article v-if="me">
      <div v-if="lastApp" class="text-center mb-5">
        <router-link class="text-decoration-underline" :to="{ name: 'Play', params: { app: lastApp.path }}">プレイ中のゲームへ戻る</router-link>
      </div>

      <h1 class="text-center mb-5">アカウント</h1>

      <ul class="list-group mb-2">
        <a class="list-group-item" href="/player/credit_edit" @click.prevent="$refs.rakutenCreditModal.show()"><i class="fa-regular fa-credit-card"></i> クレジットカードの登録・変更</a>
      </ul>
      
      <ul class="list-group mb-4">
        <router-link :to="{ name: 'History' }" class="list-group-item"><i class="fa-solid fa-list"></i> ご利用履歴</router-link>
      </ul>

      <h3 class="mb-2 fs-5">ウォレットチャージ</h3>
      <div class="text-center mb-2">
        ウォレット残高：<strong>{{ me.total.toLocaleString() }}</strong> 円
      </div>
      <div class="paymentTypes">
        <a class="credit" href="javascript:;" @click.prevent="openCreditAmountModal()">
          <div class="logo"><i class="creditIcon fa-regular fa-credit-card"></i></div>
          <div class="title">クレジットカード</div>
        </a>
        <a class="googlePay" href="javascript:;" @click.prevent="googlePayAmountModalOpen()">
          <div class="logo"><img src="/assets/google-pay-mark_800.svg" class="googlePayIcon" /></div>
          <div class="title">Google Pay</div>
        </a>
        <a class="amazonPay" href="javascript:;" @click.prevent="amazonPayAmountModal = true">
          <div class="logo"><img src="/assets/amapay/Black-M.png" class="amazonPayIcon" /></div>
          <div class="title">Amazon Pay</div>
        </a>
        <a class="ganb" href="javascript:;" @click.prevent="$refs.ganbModal.show()">
          <div class="logo"><i class="ganbIcon fa-sharp fa-regular fa-building-columns"></i></div>
          <div class="title">銀行振込</div>
        </a>
        <a class="cvs" href="javascript:;" @click.prevent="openCvsAmountModal()">
          <div class="logo"><i class="cvsIcon fa-regular fa-shop"></i></div>
          <div class="title">コンビニ払い</div>
        </a>
      </div>

      <h2 class="mb-3 fs-5">お客様情報</h2>
      <ul class="list-group mb-3">
        <router-link :to="{ name: 'Google' }" class="list-group-item">Googleログイン連携設定</router-link>
        <router-link :to="{ name: 'Email' }" class="list-group-item">メールアドレスの変更</router-link>
        <router-link :to="{ name: 'Password' }" class="list-group-item">パスワードの{{ me.password ? '変更' : '登録' }}</router-link>
        <a class="list-group-item" href="/player/logout">ログアウト</a>
      </ul>

      <h2 class="mb-3 fs-5">サポート</h2>
      <ul class="list-group mb-3">
        <!-- <a href="javascript:;" target="_blank" class="list-group-item">FAQ</a> -->
        <router-link :to="{ name: 'Withdraw' }" class="list-group-item">アカウントの閉鎖</router-link>
        <a href="https://docs.google.com/forms/d/e/1FAIpQLSdwk1pTIz_-PA0NAqCRwKEGSqROwDBv_6vibooaYcPcu2_VTA/viewform?usp=sharing" target="_blank"  class="list-group-item">お問い合わせフォーム</a>
      </ul>
      <div>&nbsp;</div>

    </article>

    <!--credit-->
    <Modal v-model="creditAmountModal" title="クレジットチャージ金額を選択">
      <ul class="list-group mb-3">
        <a v-for="v of config.ganbAmounts" class="list-group-item text-center" href="javascript:;" @click.prevent="creditChargeConfirm(v)">{{ v.toLocaleString() }}円</a>
      </ul>
      <div class="mb-3">
        <label for="loginPassword" class="form-label">チャージ金額</label>
        <form @submit.prevent="creditChargeConfirm(amount)">
          <div>
            <input type="number" class="form-control" v-model="amount" placeholder="金額を入力" min="1" max="1000000" required />
          </div>
          <div class="mt-2">
            <button type="submit" class="btn btn-dark d-block w-100">次へ</button>
          </div>
        </form>
      </div>
    </Modal>

    <Modal v-model="creditConfirmModal" title="TapFunウォレットへのチャージ" modalClass="creditConfirmModal">
      <div class="mb-2">
        <form class="rakutenCreditContainer" @submit.prevent="creditCharge(amount)">
          <div class="mb-2 text-center">チャージ金額</div>
          <div class="mb-3 text-center">
             <span class="fw-bold display-6">{{ amount.toLocaleString() }} 円</span>
          </div>
          <div class="mt-2 text-start">
            <label class="form-label">使用するクレジットカード</label>
            <div class="cardNumber">
              <span class="me-2 d-inline-block">**** **** **** {{ me.creditSuffix }}</span>
              <span class="d-inline-block">({{ me.creditMonth }} / {{ me.creditYear }}) <span v-if="me.creditBrandIconClass !== null" class="brandIcon ms-1"><i :class="me.creditBrandIconClass"></i></span></span>
            </div>
            <div class="mt-2 text-center" v-if="me.creditCvvNone">
              <a class="link" href="javascript:;" @click.prevent="$refs.rakutenCreditModal.show()">カードを変更</a>
            </div>
          </div>
          <div class="mt-2 text-start" v-show="!me.creditCvvActive">
            <label class="form-label">セキュリティコード</label>
            <div>
              <div class="rakuten-credit-input-wrapper cvv-input">
                <div id="purchase-modal-cvv-mount"></div>
              </div>
            </div>
          </div>
          <div class="mt-2">
            <button type="submit" class="btn btn-dark d-block w-100">チャージする</button>
          </div>
        </form>
      </div>
      <hr />
      <div class="text-center mt-2">
        <a href="javascript:;" class="text-secondary text-decoration-underline" @click.prevent="$refs.rakutenCreditModal.show(amount, true)">カードを変更</a>
      </div>
    </Modal>

    <!--amazonPay-->
    <Modal v-model="amazonPayAmountModal" title="AmazonPay チャージ金額を選択">
      <ul class="list-group mb-3">
        <a v-for="v of config.amazonPayAmounts" class="list-group-item text-center" href="javascript:;" @click.prevent="amazonPayChargeSubmit(v)">{{ v.toLocaleString() }}円</a>
      </ul>
      <div class="mb-3">
        <label for="loginPassword" class="form-label">チャージ金額</label>
        <form @submit.prevent="amazonPayChargeSubmit(amount)">
          <div>
            <input type="number" class="form-control" v-model="amount" placeholder="金額を入力" min="1" max="1000000" required />
          </div>
          <div class="mt-2">
            <button type="submit" class="btn btn-dark d-block w-100">次へ</button>
          </div>
        </form>
      </div>
    </Modal>

    <!--ganb-->
    <Modal v-model="ganbAmountModal" title="銀行振込チャージ金額を選択">
      <ul class="list-group mb-3">
        <a v-for="v of config.ganbAmounts" class="list-group-item text-center" href="javascript:;" @click.prevent="ganbChargeConfirm(v)">{{ v.toLocaleString() }}円</a>
      </ul>
      <div class="mb-3">
        <label for="loginPassword" class="form-label">チャージ金額</label>
        <form @submit.prevent="ganbChargeConfirm(amount)">
          <div>
            <input type="number" class="form-control" v-model="amount" placeholder="金額を入力" min="1" max="1000000" required />
          </div>
          <div class="mt-2">
            <button type="submit" class="btn btn-dark d-block w-100">次へ</button>
          </div>
        </form>
      </div>
    </Modal>
    <Modal v-model="ganbConfirmModal" title="振込情報をメールでお知らせします">
      <form @submit.prevent="ganbCharge(amount)">
        <div class="alert alert-light fs-4 text-center fw-bold email">
          <div class="mb-2">{{ me.email }}</div>
          <hr>
          <div class="mt-2">{{ amount.toLocaleString() }}円</div>
        </div>
        <div class="mb-3">
          <button type="submit" class="btn btn-dark fw-bold w-100">送信</button>
        </div>
        <div class="mb-4 text-center">
          <a href="javascript:;" class="text-decoration-underline" @click.prevent="openGanbAmountModal()">金額を変更</a>
        </div>
      </form>
    </Modal>
    <Modal v-model="ganbCompleteModal" title="振込情報を送信しました">
      <div class="mt-3 mb-4 text-center">
        受信メールをご確認ください。
      </div>
      <div class="mb-3 text-center">
        <button type="button" class="btn btn-outline-dark" @click.prevent="ganbCompleteModal = false">閉じる</button>
      </div>
    </Modal>

    <Modal v-model="cvsAmountModal" title="コンビニチャージ金額を選択">
      <label class="form-label">手数料：{{ config.cvsCommisionAmount }}円</label>
      <ul class="list-group mb-3">
        <a v-for="v of config.cvsAmounts" class="list-group-item text-center" href="javascript:;" @click.prevent="cvsChargeSubmit(v)">{{ v.toLocaleString() }}円 (+{{ config.cvsCommisionAmount }}円)</a>
      </ul>
      <label class="form-label">{{ config.cvsCommisionThresholdAmount.toLocaleString() }}円以上は<strong>手数料無料</strong></label>
      <ul class="list-group mb-3">
        <a v-for="v of config.cvsCommissionFreeAmounts" class="list-group-item text-center" href="javascript:;" @click.prevent="cvsChargeSubmit(v)">{{ v.toLocaleString() }}円</a>
      </ul>
    </Modal>
    <Modal v-model="amazonPayChargedModal" title="チャージが完了しました" :modalClass="amazonPayChargedModal">
      <div class="text-center">
        <div class="mb-3">
          <div class="alert alert-success">
            {{ amazonPayChargedAmount.toLocaleString() }}円のチャージが完了しました。
          </div>
        </div>
        <div>
          <button type="button" class="btn btn-dark" @click.prevent="amazonPayChargedModal = false">閉じる</button>
        </div>
      </div>
    </Modal>
    <Modal v-model="googlePayAmountModal" title="Google Pay チャージ金額を選択">
      <ul class="list-group mb-3">
        <a v-for="v of config.amazonPayAmounts" class="list-group-item text-center" href="javascript:;" @click.prevent="googlePayNext(v)">{{ v.toLocaleString() }}円</a>
      </ul>
      <div class="mb-3">
        <label for="loginPassword" class="form-label">チャージ金額</label>
        <form @submit.prevent="googlePayNext(amount)">
          <div>
            <input type="number" class="form-control" v-model="amount" placeholder="金額を入力" min="1" max="100000" required />
          </div>
          <div class="mt-3">
            <button type="submit" class="btn btn-dark w-100">次へ</button>
          </div>
          <!-- <div class="mt-3 text-center" ref="googlePayButton"> -->
          <!-- </div> -->
        </form>
      </div>
    </Modal>
    <Modal v-model="googlePayConfirmModal" title="TapFunウォレットへのチャージ">
      <div class="mb-3">
        <div class="mb-2 text-center">チャージ金額</div>
        <div class="mb-3 text-center">
           <span class="fw-bold display-6">{{ amount.toLocaleString() }} 円</span>
        </div>
        <div class="mt-3 text-center" ref="googlePayButton">
        </div>
      </div>
    </Modal>
    <Modal v-model="googlePayChargedModal" title="チャージが完了しました" :modalClass="googlePayChargedModal">
      <div class="text-center">
        <div class="mb-3">
          <div class="alert alert-success">
            {{ amount.toLocaleString() }}円のチャージが完了しました。
          </div>
        </div>
        <div>
          <button type="button" class="btn btn-dark" @click.prevent="googlePayChargedModal = false">閉じる</button>
        </div>
      </div>
    </Modal>
    <RakutenCreditModal :me="me" ref="rakutenCreditModal" :showLoadingOverlay="showLoadingOverlay" :hideLoadingOverlay="hideLoadingOverlay" :session="session" :closeModal="rakutenCreditModalClose" />
    <GanbModal :me="me" ref="ganbModal" :showLoadingOverlay="showLoadingOverlay" :hideLoadingOverlay="hideLoadingOverlay" />
  </LayoutHeader>
</template>

<script>
import baseMixin from './base';
import config from '../lib/config';
import RakutenCreditModal from './Components/RakutenCreditModal.vue';
import GanbModal from './Components/GanbModal.vue';
import { toast } from 'vue3-toastify';

export default {
  mixins: [
    baseMixin,
  ],
  components: {
    RakutenCreditModal,
    GanbModal,
  },
  data () {
    return {
      titlePrefix: 'アカウント',
      creditAmountModal: false,
      creditConfirmModal: false,
      amount: this.$route.query.amount ? this.$route.query.amount : '',
      amounts: [
        1000,
        3000,
        5000,
        10000,
      ],
      cvsAmountModal: this.$route.query.cvs ? true : false,
      amazonPayAmountModal: this.$route.query.amazonPay ? true : false,
      amazonPayChargedModal: false,
      amazonPayChargedAmount: null,
      googlePayAmountModal: false,
      googlePayConfirmModal: false,
      googlePayChargedModal: false,
    }
  },
  methods: {
    _mounted() {
      this.check();
    },
    _meSeted(me, session) {
      if (session && session.flash && session.flash.type == 'amazonPayCharged') {
        this.amazonPayChargedModal = true;
        this.amazonPayChargedAmount = parseInt(session.flash.amount);
      }
    },
    check: async function() {
      const res = await this.axios({
        url: '/check',
      });
    },
    googlePayAmountModalOpen() {
      this.googlePayAmountModal = true;
    },
    googlePayNext(amount) {
      this.amount = amount;
      this.googlePayAmountModal = false;
      this.googlePayConfirmModal = true;
      this.$nextTick(() => {
        this.googlePayButton(amount);
      });
    },
    googlePayButton(amount) {
      const googlePayClient = new google.payments.api.PaymentsClient({environment: this.config.GMOPG.googlePayEnvironment});
      console.log('GMOPG', this.config.GMOPG);
      const allowedCardAuthMethods = ["PAN_ONLY", "CRYPTOGRAM_3DS"];
      const allowedCardNetworks = ["AMEX", "DISCOVER", "INTERAC", "JCB", "MASTERCARD", "VISA"];

      const tokenizationSpec = {
        type: 'PAYMENT_GATEWAY',
        parameters: {
          gateway: config.GMOPG.gateway,
          gatewayMerchantId: config.GMOPG.shopId,
        }
      };
      console.log({ tokenizationSpec });

      const baseClientConfigurateion = {
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: [
          {
            type: "CARD",
            tokenizationSpecification: tokenizationSpec,
            parameters: {
              allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
              allowedCardNetworks: ["AMEX", "DISCOVER", "INTERAC", "JCB", "MASTERCARD", "VISA"]
            }
          }
        ]
      };
      const cardPaymentMethod = {
        type: 'CARD',
        tokenizationSpecification: tokenizationSpec,
        parameters: {
          allowedCardNetworks: allowedCardNetworks,
          allowedAuthMethods: allowedCardAuthMethods,
          billingAddressRequired: false,
        }
      };

      const paymentDataRequest = Object.assign({}, baseClientConfigurateion);
      paymentDataRequest.transactionInfo = {
        totalPriceStatus: 'FINAL',
        totalPrice: amount.toString(),
        currencyCode: 'JPY',
      };
      paymentDataRequest.merchantInfo = {
        merchantId: this.config.GMOPG.googlePayMerchantId,
        merchantName: 'TapFun'
      };
      console.log('merchantInfo', paymentDataRequest.merchantInfo);

      googlePayClient.isReadyToPay({
        allowedPaymentMethods: ["CARD"]
      }).then((response) => {
        if (response.result) {
          console.log('Payment結果', response.result);
          const button = googlePayClient.createButton({
            buttonColor: 'default',
            buttonType: 'long',
            onClick: onGooglePaymentsBjuttonClicked
          });
          this.$refs.googlePayButton.appendChild(button);

        }
      }).catch(function (err) {
        console.log('TEST1', err);
      });

      const onGooglePaymentsBjuttonClicked = () => {
        this.loadingOverlay = true;

        googlePayClient.loadPaymentData(paymentDataRequest).then((paymentData) => {
          googlePayClient.prefetchPaymentData(paymentDataRequest);

          const paymentToken = paymentData.paymentMethodData.tokenizationData.token;
          console.log("paymentToken:", paymentToken);
          console.log("paymentData:", paymentData)
          //return new Promise(function(resolve, reject){ })

          processPayment(paymentData)
        }).catch(err => {
          this.loadingOverlay = false;
          console.log(err.statusCode);
          console.log(err.statusMessage);
          if (err.statusCode == 'CANCELED') {
            return;
          }
          alert('エラーが発生しました。もう一度お試しください。');
        });
      }

      const processPayment = (paymentData) => {
        console.log(paymentData);
        const paymentToken = paymentData.paymentMethodData.tokenizationData.token;
        console.log(paymentToken);
        this.axios({
          url: '/googlePayCharge',
          method: 'post',
          data: {
            amount: amount,
            token: paymentToken,
          },
        }).then((res) => {
          this.session();
          this.loadingOverlay = false;
          if (res.data === false) {
            alert('Google Payの決済に失敗しました。');
            return;
          }
          this.googlePayConfirmModal = false;
          this.googlePayChargedModal = true;
        }).catch(err => {
          console.error(err);
          this.loadingOverlay = false;
          this.googlePayConfirmModal = false;
          alert('通信エラーが発生しました。チャージが完了している可能性があるため、ブラウザをリロードして確認してください。');
          this.session();
        });
      }

    },
    openCreditAmountModal() {
      this.creditAmountModal = true;
    },
    openCvsAmountModal() {
      this.cvsAmountModal = true;
    },
    async creditChargeConfirm(amount, force) {
      if (!this.me.hasCredit || force) {
        this.$refs.rakutenCreditModal.show(() => {
          this.creditChargeConfirm(amount);
        });
        return;
      }
      this.amount = amount;
      this.creditAmountModal = false;
      this.creditConfirmModal = true;

      if (!this.me.creditCvvActive) {
        this.$nextTick(() => {
          this.payvaultSetup();
        });
      }
    },
    payvaultSetup() {
      const inputElementStyles = this.$refs.rakutenCreditModal.getInputElementStyles();
      try {
        if (payvault && payvault.destroy) payvault.destroy();
      } catch (e) {
      }
      payvault.setup({
        cvv: {
          mount: '#purchase-modal-cvv-mount',
          styles: inputElementStyles,
          placeholder: 'CVV',
          height: '46px',
        },
      });
    },
    creditCharge(amount) {
      this.creditChargeProcess(amount);
      return false;
    },
    async creditChargeProcess(amount) {
      let token;
      if (!this.me.creditCvvActive) {
        const cvvLength = await payvault.card.getLength('cvv');
        if (cvvLength == 0) {
          toast('セキュリティコードを入力して下さい。', {
            type: 'error',
            transition: 'slide',
            hideProgressBar: true,
            position: 'top-center',
            autoClose: 2000,
          });
          return false;
        }
        if (!(await payvault.card.validateCvv())) {
          toast('セキュリティコードが正しくありません。', {
            type: 'error',
            transition: 'slide',
            hideProgressBar: true,
            position: 'top-center',
            autoClose: 2000,
          });
          return false;
        }

        token = await payvault.card.createToken({
          serviceId: process.env.RAKUTEN_SERVICEID,
          integrationCase: 'cvvToken',
        });
      }
      this.showLoadingOverlay();
      const form = document.createElement('form');
      const data = {
        amount: amount,
      };
      if (token) {
        data.token = token;
      }
      this.axios({
        url: '/credit/charge',
        method: 'post',
        data: data,
      }).then((r) => {
        const form = document.createElement('form');
        form.style.display = 'none';
        form.method = 'post';
        form.action = r.data.url;
        // form.target = '_blank';
        const paymentinfo = document.createElement('input');
        paymentinfo.type = 'hidden';
        paymentinfo.name = 'paymentinfo';
        paymentinfo.value = r.data.paymentinfo;
        form.appendChild(paymentinfo);
        const signature = document.createElement('input');
        signature.type = 'hidden';
        signature.name = 'signature';
        signature.value = r.data.signature;
        form.appendChild(signature);
        const keyVersion = document.createElement('input');
        keyVersion.type = 'hidden';
        keyVersion.name = 'key_version';
        keyVersion.value = r.data.keyVersion;
        form.appendChild(keyVersion);
        document.body.appendChild(form);
        form.submit();
      }).catch((e) => {
        console.error(e);
        this.hideLoadingOverlay();
        alert('通信エラーが発生しました。しばらく待ってから再度お試しください。');
      });
    },
    cvsChargeSubmit(amount) {
      this.loadingOverlay = true;
      this.axios({
        method: 'post',
        url: '/cvs',
        data: {
          amount: amount,
        },
      }).then((r) => {
        location.href = r.data.url;
        setTimeout(() => {
          this.cvsAmountModal = false;
          this.loadingOverlay = false;
        }, 1000);
      }).catch((e) => {
        console.error(e);
        alert('通信エラーが発生しました。しばらく待ってから再度お試しください。');
        this.loadingOverlay = false;
      });
    },
    amazonPayChargeSubmit(amount) {
      this.loadingOverlay = true;
      this.axios({
        method: 'post',
        url: '/amazonpay',
        data: {
          amount: amount,
        },
      }).then((r) => {
        const form = document.createElement('form');
        form.style.display = 'none';
        form.method = 'POST';
        form.action = r.data.url;
        const accessId = document.createElement('input');
        accessId.type = 'hidden';
        accessId.name = 'AccessID';
        accessId.value = r.data.accessId;
        form.appendChild(accessId);
        const token = document.createElement('input');
        token.type = 'hidden';
        token.name = 'Token';
        token.value = r.data.token;
        form.appendChild(token);
        document.body.appendChild(form);
        setTimeout(() => {
          form.submit();
          setTimeout(() => {
            this.amazonPayAmountModal = false;
            this.loadingOverlay = false;
          }, 1000);
        }, 1000);
      }).catch((e) => {
        console.error(e);
        alert('通信エラーが発生しました。しばらく待ってから再度お試しください。');
        this.loadingOverlay = false;
      });
    },
    rakutenCreditModalClose() {
      console.log('rakutenCreditModalClose');
      if (this.creditConfirmModal) {
        if (!this.me.hasCredit) {
          this.creditConfirmModal = false;
          return;
        }
        this.payvaultSetup();
      }
    },
  },
}
</script>

